import AddCountry from "../../Components/Modals/AddCountry";
import Table from "../../Components/Table";
import { deleteCountryById, getAllCountry } from "../../Services/MasterService";

const Country = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Phone Code",
            value: "phone_code"
        },

        {
            label: "Logo",
            value: "logo",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
        {
            label: "Flag",
            value: "flag",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
        {
            label: "Alias",
            value: "alias"
        },
        {
            label: "Status",
            value: "status_name",
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCountry data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCountry}
            columns={columns}
            title={"Country Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCountryById}
        />
    );
}

export default Country;